/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState } from "react";
import { useContext } from "../../../context";
import {
  displayName,
  showFormattedDate,
} from "../../../../../../../../../Utils";

const getAction = (obj) => {
  let action = "";

  if (obj.action == "booked") {
    action = " Booked on ";
  } else if (obj.action == "marknoshow") {
    action = " Mark no show on ";
  } else if (obj.action == "cancel") {
    action = " Cancelled on ";
  } else if (obj.action == "checkedin") {
    action = " Checked in on ";
  } else if (obj.action == "confirmed") {
    action = " Confirmed on ";
  } else if (
    (obj.action == "reschedule" || obj.action == "edit") &&
    obj.child != "notes"
  ) {
    action = " Rescheduled on ";
  } else if (obj.action == "edit" && obj.child == "notes") {
    action = " has Updated Appointment Note on";
  }

  return action;
};

export function BookingDate() {
  const { appointment } = useContext();
  const [showBookings, setShowBookings] = useState(false);

  return (
    <div className="detail-row">
      <label>Date of Booking:</label>
      <span
        className="eventBookingDate"
        onClick={() => setShowBookings(!showBookings)}
      >
        {showFormattedDate(appointment.bookingDateTime, true)}{" "}
        <i className="fa fa-clock clockIconEvenDetail"></i>
        {showBookings && (
          <span className="appoint-pro-edit">
            {appointment.isAdditionalProviderAppointment ? (
              <span>Booking History is viewable on main Provider schedule</span>
            ) : (
              <ul className="log-appoint-his">
                {appointment.userLogs.map((obj, idx) => (
                  <li key={"customer_bookings-" + idx}>
                    {displayName(obj.user)} {getAction(obj)}{" "}
                    {showFormattedDate(obj.created, true)}
                  </li>
                ))}
              </ul>
            )}
          </span>
        )}
      </span>
    </div>
  );
}
